import React from "react";
import { Modal } from "../../";

const SetupModal = ({
  isOpen,
  onClose,
  title,
  url,
  parseTemplate,
  variables,
}) => {
  if (!isOpen || !url) return null;

  const parsedUrl = parseTemplate ? parseTemplate(url, variables) : url;

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={title || "Integration Setup"}
      size="xl"
    >
      <div className="h-[80vh] w-full">
        <iframe
          src={parsedUrl}
          title={title || "Integration Setup"}
          className="h-full w-full rounded-lg border-0"
          sandbox="allow-scripts allow-same-origin allow-forms allow-popups allow-top-navigation"
          loading="lazy"
        />
      </div>
    </Modal>
  );
};

export default SetupModal;
